import React from 'react';

const PageNav = () => {
  const navLinks = [
    { label: 'Tjenester', href: '/tjenester-services' },
    { label: 'Om Oss', href: '/om-oss-about-us' },
    { label: 'Kontakt', href: '/nord-pass-contact-page' }
  ];

  return (
    <nav style={{
      position: 'fixed',
      top: 0, left: 0, right: 0,
      zIndex: 100,
      background: 'rgba(5,10,18,0.92)',
      backdropFilter: 'blur(16px)',
      borderBottom: '1px solid rgba(255,255,255,0.06)'
    }}>
      <div style={{
        maxWidth: '1400px',
        margin: '0 auto',
        padding: '0 5%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        height: '72px'
      }}>
        <a href="/nord-pass-landing-page" style={{
          display: 'flex',
          alignItems: 'center',
          gap: '10px',
          textDecoration: 'none'
        }}>
          <div style={{
            width: '32px',
            height: '32px',
            background: '#3B6FD4',
            clipPath: 'polygon(0 0, calc(100% - 8px) 0, 100% 8px, 100% 100%, 8px 100%, 0 calc(100% - 8px))'
          }} />
          <span style={{
            fontFamily: 'Syne, sans-serif',
            fontSize: '1.125rem',
            fontWeight: 800,
            color: '#EEF0F2',
            letterSpacing: '-0.03em'
          }}>NordPass</span>
        </a>

        <div style={{ display: 'flex', alignItems: 'center', gap: '40px' }}>
          {navLinks?.map((link, i) => (
            <a
              key={i}
              href={link?.href}
              style={{
                fontFamily: 'Inter, sans-serif',
                fontSize: '0.875rem',
                color: 'rgba(238,240,242,0.65)',
                textDecoration: 'none',
                transition: 'color 150ms ease'
              }}
              onMouseEnter={e => { e.currentTarget.style.color = '#EEF0F2'; }}
              onMouseLeave={e => { e.currentTarget.style.color = 'rgba(238,240,242,0.65)'; }}
            >
              {link?.label}
            </a>
          ))}
        </div>

        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
          <a href="/login" style={{
            fontFamily: 'Inter, sans-serif',
            fontSize: '0.875rem',
            color: 'rgba(238,240,242,0.65)',
            textDecoration: 'none',
            padding: '8px 16px'
          }}>Logg inn</a>
          <a href="/login" style={{
            fontFamily: 'Syne, sans-serif',
            fontSize: '0.8125rem',
            fontWeight: 700,
            color: '#EEF0F2',
            textDecoration: 'none',
            padding: '10px 20px',
            background: '#3B6FD4',
            letterSpacing: '0.06em',
            textTransform: 'uppercase'
          }}>Start gratis</a>
        </div>
      </div>
    </nav>
  );
};

export default PageNav;
